import { FormControl } from '@angular/forms';
import { SupportedFormats } from './media-library/conversion';

export interface FormModalConversion {
	name: FormControl<string>;
	from: FormControl<SupportedFormats>;
	to: FormControl<SupportedFormats>;
}
